import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'events';
export const eventsActions = makeActions(MODEL_NAME);

export const getAllEvents = eventsActions.getAll;
export const editEvents = eventsActions.edit;
export const createEvents = eventsActions.create;
export const getByIdEvents = eventsActions.getDataById;
